class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.addToCart.bind(this));
  }

  addToCart() {
    // 1. Safety check
    if (this.hasAttribute('disabled') || this.classList.contains('atc-loading')) return;

    const variantId = this.getAttribute('data-variant-id');
    const preorderNote = this.getAttribute('data-pre-order-note');
    console.log(preorderNote)

    // 2. Show the spinner
    this.classList.add('atc-loading');

    // 3. Prepare data for Shopify Cart API
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'properties': {}
      }]
    };
    if (preorderNote && preorderNote !== '' && preorderNote !== 'null') {
      formData.items[0].properties['Pre-order'] = preorderNote;
    }

    // 4. Send AJAX request to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async (response) => {
      // Check if Shopify returned an error (e.g., 422 for max inventory reached)
      if (!response.ok) {
        const errorData = await response.json();
        // Throwing this sends it straight to the catch() block below
        throw new Error(errorData.description || 'Error adding to cart'); 
      }
      return response.json();
    })
    .then(data => {
      console.log('Item added to cart:', data);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      // Optional: Trigger cart drawer or redirect here
    })
    .catch((error) => {
      console.error('Cart Error:', error);
      // 5. Call the error display function
      this.showError(error.message); 
    })
    .finally(() => {
      // 6. Remove the spinner once complete
      this.classList.remove('atc-loading');
    });
  }

  // --- New method to handle temporary error messages ---
  showError(message) {
    // Find the parent tile of the button that was clicked
    const tile = this.closest('.product-showcase-tile');
    if (!tile) return;

    // Find the error div inside that specific tile
    const errorDiv = tile.querySelector('.error');
    if (errorDiv) {
      // Inject Shopify's exact error description
      errorDiv.textContent = message; 
      
      // Show the error
      errorDiv.classList.add('visible');

      // Hide the error after 3 seconds (3000 milliseconds)
      setTimeout(() => {
        errorDiv.classList.remove('visible');
      }, 3000);
    }
  }
}

// Register the custom element with the browser
if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button', QuickAddButton);
}